/* eslint-disable @typescript-eslint/naming-convention */
import { createTechArticleSchema, ProficiencyLevel } from './schemaHelpers';

interface Params {
  blok: {
    meta_title?: string;
    meta_description?: string;
    author?: string;
    proficiencyLevel?: ProficiencyLevel;
    dependencies?: string;
  };
  storyData: {
    date_published: string;
    full_slug: string;
  };
  siteMetadata: {
    siteUrl: string;
    APP_NAME: string;
  };
}

export const getTechArticleSchema = ({
  blok,
  storyData,
  siteMetadata,
}: Params) => {
  const {
    meta_title,
    meta_description,
    author,
    proficiencyLevel,
    dependencies,
  } = blok;

  if (!meta_title || !meta_description || !author) return null;

  const resolvedSlug = storyData.full_slug.replace(/^categories\//, '');
  const pageUrl = `${siteMetadata.siteUrl}/${resolvedSlug}`;

  return createTechArticleSchema({
    title: meta_title,
    description: meta_description,
    authorName: author,
    authorUrl: author,
    publishDate: storyData.date_published,
    proficiencyLevel,
    dependencies,
    pageUrl,
  });
};
